import { IBooleanResponse, ICursorRequest } from '@gem/models/commonModel';
import { logger } from '@gem/modules/logger';

import {
  addStickerPackToProfileRequest,
  getStickerPackByIdRequest,
  getStickerPacksRequest,
  getUserInstalledStickerPacksRequest,
  removeStickerPackFromProfileRequest,
} from 'APP/wsApi/wsAppApi/requests/stickersRequests';

import { buildModelError } from '../error/errorBuilder';
import { mapPublicStickerPacksResponse, mapStickerPack } from './stickersModel.b2b.mapper';
import {
  IStickerPackExtend,
  IStickerPackRequest,
  IStickerPacksList,
  IUserStickerPacks,
} from './stickersModel.types';

export const getPublicStickerPacks = async (data: ICursorRequest): Promise<IStickerPacksList> => {
  try {
    const response = await getStickerPacksRequest(data);
    if (response.type.case === 'success') {
      return mapPublicStickerPacksResponse(response.type.value.stickerPacksEnriched);
    } else {
      throw response.type.value;
    }
  } catch (error) {
    logger.get('API').error('stickers.getPublicStickerPacks', error);
    throw buildModelError(error);
  }
};

export const getUserInstalledStickerPacks = async (): Promise<IUserStickerPacks> => {
  try {
    const response = await getUserInstalledStickerPacksRequest({});

    if (response.type.case === 'success') {
      return mapPublicStickerPacksResponse(response.type.value.stickerPacksEnriched);
    } else {
      throw response.type.value;
    }
  } catch (error) {
    logger.get('API').error('stickers.getUserInstalledStickerPacks', error);
    throw buildModelError(error);
  }
};

export const addStickerPackToProfile = async (
  data: IStickerPackRequest
): Promise<IBooleanResponse> => {
  try {
    const response = await addStickerPackToProfileRequest({
      stickerPackId: BigInt(data.stickerPackId),
    });

    if (response.type.case === 'success') {
      return { result: true };
    } else {
      throw response.type.value;
    }
  } catch (error) {
    logger.get('API').error('stickers.addStickerPackToProfile', error);
    throw buildModelError(error);
  }
};

export const getStickerPackById = async (
  data: IStickerPackRequest
): Promise<IStickerPackExtend> => {
  try {
    const response = await getStickerPackByIdRequest({
      id: BigInt(data.stickerPackId),
    });
    if (response.type.case === 'success') {
      return mapStickerPack(response.type.value.stickerPacksEnriched!);
    } else {
      throw response.type.value;
    }
  } catch (error) {
    logger.get('API').error('stickers.getStickerPackById', error);
    throw buildModelError(error);
  }
};

export const removeStickerPackFromProfile = async (
  data: IStickerPackRequest
): Promise<IBooleanResponse> => {
  try {
    const response = await removeStickerPackFromProfileRequest({
      stickerPackId: BigInt(data.stickerPackId),
    });

    if (response.type.case === 'success') {
      return { result: true };
    } else {
      throw response.type.value;
    }
  } catch (error) {
    logger.get('API').error('stickers.removeStickerPackFromProfile', error);
    throw buildModelError(error);
  }
};
